<template>
  <BasePageContainer
    class="pt-10">
    <PageHeader
      has-back
      with-members>
      身長体重管理
    </PageHeader>
    <template v-if="initialized">
      <BodyMeasurementsForm
        v-if="bodyMeasurement"
        ref="form"
        :body-measurement="bodyMeasurement"
        @submit="onSubmit" />
      <div class="d-flex justify-content-start mt-4">
        <button
          type="button"
          class="btn d-block text-right text--grey09 d-flex align-items-center"
          @click="onClickDelete">
          <span class="material-icons mr-1">
            delete
          </span>
          削除する
        </button>
      </div>
    </template>
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import BodyMeasurementsForm from '@/components/view/profile/body_measurements/BodyMeasurementsForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    BodyMeasurementsForm
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      initialized: false,
      bodyMeasurement: null,
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    },
    bodyMeasurementId() {
      return this.$route.params.bodyMeasurementId
    }
  },
  created() {
    this.fetchBodyMeasurement().then(res => {
      this.bodyMeasurement = res.data
    }).finally(() => {
      this.initialized = true
    })
  },
  methods: {
    onSubmit(formData) {
      this.patchBodyMeasurements(formData).then(() => {
        this.$store.commit('notify/set', {message: '身長体重を更新しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      })
    },
    fetchBodyMeasurement() {
      return this.$axios.get(`/profiles/body-measurements/${this.bodyMeasurementId}/`)
    },
    patchBodyMeasurements(formData) {
      return this.$axios.patch(`/profiles/body-measurements/${this.bodyMeasurementId}/`, formData)
    },
    onClickDelete() {
      if (!window.confirm('この学年を削除してもよろしいですか？削除するとこの学年に入力した記録もすべて削除されます。')) return
      this.deleteBodyMeasurement().then(() => {
        this.$store.commit('notify/set', {message: '身長体重を削除しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      })
    },
    deleteBodyMeasurement() {
      return this.$axios.delete(`/profiles/body-measurements/${this.bodyMeasurementId}/`)
    }
  }
}

</script>

<style>

</style>